<div class=" header bg-gradient-nhc-orange pb-6">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
        <div class=" col-lg-6 col-7">
          <nav
            aria-label="breadcrumb"
            class=" d-none d-md-inline-block ml-md-4"
          >
            <ol class=" breadcrumb breadcrumb-links breadcrumb-dark">
              <li class=" breadcrumb-item">
                <a [routerLink]="['/']" href="javascript:void(0)">
                  <i class=" fas fa-home"></i>
                </a>
              </li>

              <li class=" breadcrumb-item">
                <a [routerLink]="['/applications']" href="javascript:void(0)"> Application </a>
              </li>

              <li class=" breadcrumb-item">
                <a [routerLink]="['/applications','details', reportData?.grantApplicationId]"
                   href="javascript:void(0)"> {{ reportData?.grantApplicationName }} </a>
              </li>

              <li class=" breadcrumb-item">
                <a href="javascript:void(0)"> {{ reportData?.reportType }} </a>
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>

<div class=" container-fluid mt--6">
  <section class="section" id="project-detail">
    <div class="row">
      <div class="col-lg-8 col-md-12 col-sm-12">
        <div class=" card-wrapper" id="projectInfo">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-md-9 col-lg-9 col-sm-12">
                  <h3 class=" mb-0">Report</h3>
                </div>
              </div>


            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                  <div class="form-group">
                    <h4>Report Type</h4>
                    <span>{{ reportData?.reportType ?? '-' }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <h4>Due Date</h4>
                    <span>{{ ((reportData?.dueDate ?? null) !== null) ? (reportData?.dueDate | date:'dd/MM/yyyy') : '-' }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <h4>Report Status</h4>
                    <span>{{ reportData?.reportStatus ?? '-' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <form (ngSubmit)="onSubmit()" [formGroup]="applicationForm!">
          <!-- FUND STATUS -->
          <div *ngIf="reportData?.reportTypeCode == 'StatusReportNarrative' || reportData?.reportTypeCode == 'FinalReportNarrative'"
               class=" card-wrapper">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-md-9 col-lg-9 col-sm-12">
                    <h3 class=" mb-0">
                      Project Fund Status
                    </h3>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="p-2 mb-2">
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label class="form-control-label">Amount Received</label>
                        <ul class="description-list small text-muted">
                          <li>
                            Please state the total,
                          </li>
                          <li>
                            and specify all tranches you have received so far,
                          </li>
                          <li>
                            with reception dates and exchange rate.
                          </li>
                        </ul>
                        <input
                          class="form-control"
                          [ngClass]="{ 'is-invalid': applicationForm.get('amountReceive')?.invalid && applicationForm.get('amountReceive')?.touched }"
                          formControlName="amountReceive"
                          type="number"
                          step="1"
                          [min]="reportAmount.min" [max]="reportAmount.max"/>
                        <div *ngIf="applicationForm.get('amountReceive')?.invalid && applicationForm.get('amountReceive')?.touched" class="invalid-feedback">
                          <div *ngIf="applicationForm.get('amountReceive')?.hasError('min')">
                            Amount must be greater than or equal to 0.
                          </div>
                          <div *ngIf="applicationForm.get('amountReceive')?.hasError('required')">
                            This field is required.
                          </div>
                          <div *ngIf="applicationForm.get('amountReceive')?.hasError('wholeNumber')">
                            Please enter a whole number (no decimals).
                          </div>
                          <div *ngIf="applicationForm.get('amountReceive')?.hasError('max')">
                            Amount cannot exceed {{ reportAmount.max | number }}.
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="form-control-label">Amount Spent</label>
                        <ul class="description-list small text-muted">
                          <li>
                            The amount you have spent of the total grant.
                          </li>
                        </ul>
                        <input [ngClass]="{ 'is-invalid': applicationForm.get('amountSpent')?.invalid
                              && applicationForm.get('amountSpent')?.touched }" class="form-control"
                               formControlName="amountSpent"
                               type="number"
                               step="1"
                               [min]="reportAmount.min" [max]="reportAmount.max"/>

                        <div *ngIf="applicationForm.get('amountSpent')?.invalid && applicationForm.get('amountSpent')?.touched" class="invalid-feedback">
                          <div *ngIf="applicationForm.get('amountSpent')?.hasError('min')">
                            Amount must be greater than or equal to 0.
                          </div>
                          <div *ngIf="applicationForm.get('amountSpent')?.hasError('required')">
                            This field is required.
                          </div>
                          <div *ngIf="applicationForm.get('amountSpent')?.hasError('wholeNumber')">
                            Please enter a whole number (no decimals).
                          </div>
                          <div *ngIf="applicationForm.get('amountSpent')?.hasError('max')">
                            Amount cannot exceed {{ reportAmount.max | number }}.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label class="form-control-label">Amount Remaining</label>
                        <input [ngClass]="{ 'is-invalid': applicationForm.get('amountRemaining')?.invalid
                              && applicationForm.get('amountRemaining')?.touched }" class="form-control" formControlName="amountRemaining"
                               readonly="readonly"
                               type="number"
                               step="1"/>
                      </div>
                    </div>
                    <div class="col-6">
                      <div *ngIf="reportData?.reportTypeCode == 'StatusReportNarrative' || reportData?.reportTypeCode == 'FinalReportNarrative'"
                           class="form-group">
                        <label class="form-control-label">Budget Next Period</label>
                        <input [ngClass]="{ 'is-invalid': applicationForm.get('budgetNextPeriod')?.invalid
                              && applicationForm.get('budgetNextPeriod')?.touched }" class="form-control"
                               formControlName="budgetNextPeriod"
                               type="number"
                               step="1"
                               [min]="reportAmount.min" [max]="reportAmount.max"/>
                        <div *ngIf="applicationForm.get('budgetNextPeriod')?.invalid && applicationForm.get('budgetNextPeriod')?.touched" class="invalid-feedback">
                          <div *ngIf="applicationForm.get('budgetNextPeriod')?.hasError('min')">
                            Amount must be greater than or equal to 0.
                          </div>
                          <div *ngIf="applicationForm.get('budgetNextPeriod')?.hasError('required')">
                            This field is required.
                          </div>
                          <div *ngIf="applicationForm.get('budgetNextPeriod')?.hasError('wholeNumber')">
                            Please enter a whole number (no decimals).
                          </div>
                          <div *ngIf="applicationForm.get('budgetNextPeriod')?.hasError('max')">
                            Amount cannot exceed {{ reportAmount.max | number }}.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- FINACIAL STATUS -->
          <div *ngIf="reportData?.reportTypeCode == 'FinalReportFinancial' || reportData?.reportTypeCode == 'StatusReportFinancial' " class=" card-wrapper">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-md-9 col-lg-9 col-sm-12">
                    <h3 class=" mb-0">
                      {{reportData?.reportTypeCode == 'FinalReportFinancial' ? 'Final Financial Report - Tasks' : 'Financial Status Report'}}
                    </h3>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="p-2 mb-2">
                  <div class="table-responsive">
                    <table class="table align-items-center table-flush">
                      <thead class="thead-light">
                      <tr>
                        <th scope="col">Task</th>
                        <th scope="col">Status</th>
                      </tr>
                      </thead>

                      <tbody class="list" formArrayName="financialTasks">
                      <tr *ngFor="let task of financialTasksFormArray.controls; let i = index" [formGroupName]="i">
                        <td>
                          {{ task.get('name')?.value }}
                        </td>
                        <td>
                          <select class="form-control" formControlName="status">
                            <option value="Complete">Complete</option>
                            <option value="Not Complete">Not Complete</option>
                          </select>
                        </td>
                      </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- FINAL REPORT -->
          <div *ngIf="reportData?.reportTypeCode == 'FinalReportNarrative'" class=" card-wrapper">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-md-9 col-lg-9 col-sm-12">
                    <h3 class=" mb-0">
                      Final Narrative Report
                    </h3>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="p-2 mb-2">
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label class="form-control-label">Was this project co-funded by other donor?</label>
                        <select [ngClass]="{ 'is-invalid': applicationForm.get('isCofunded')?.invalid
                            && applicationForm.get('isCofunded')?.touched }" class="form-control"
                                formControlName="isCofunded"
                                id="isCofunded">
                          <option [value]="1">Yes</option>
                          <option [value]="0">No</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="(applicationForm.get('isCofunded')?.value ?? '0') == '1'" class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="form-control-label">Co-funding Details (Max {{ reportLimits.cofundingDescription }} characters)</label>
                        <p class="small text-muted">Please indicate a) name of donor, b) what amount and c) contact
                          person from this donor.</p>
                        <textarea [ngClass]="{ 'is-invalid': applicationForm.get('cofundingDescription')?.invalid
                                  && applicationForm.get('cofundingDescription')?.touched }"
                                  class="form-control"
                                  formControlName="cofundingDescription" rows="7"
                                  [maxlength]="reportLimits.cofundingDescription"></textarea>
                        <app-char-counter [control]="applicationForm.get('cofundingDescription')"
                                          [max]="reportLimits.cofundingDescription"
                                          [lineBreakCost]="1"></app-char-counter>
                        <div class="invalid-feedback">
                          <div *ngIf="applicationForm.get('cofundingDescription')?.hasError('notBlank')">
                            Please enter some text or leave this field empty.
                          </div>
                          <div *ngIf="applicationForm.get('cofundingDescription')?.hasError('maxlength')">
                            Co-funding Details cannot exceed {{ reportLimits.cofundingDescription }} characters.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="form-control-label">Project implementation description (Max {{ reportLimits.projectImplementDescription }} characters)</label>
                        <p class="small text-muted">Describe what results you have achieved for your target groups and
                          mention the main activities you have carried out. without too much detail. This will be used
                          for specific purposes, such as NHC reporting back to donors.</p>
                        <textarea [ngClass]="{ 'is-invalid': applicationForm.get('projectImplementDescription')?.invalid
                                  && applicationForm.get('projectImplementDescription')?.touched }"
                                  class="form-control"
                                  formControlName="projectImplementDescription" rows="7"
                                  [maxlength]="reportLimits.projectImplementDescription"></textarea>
                        <app-char-counter [control]="applicationForm.get('projectImplementDescription')"
                                          [max]="reportLimits.projectImplementDescription"
                                          [lineBreakCost]="1"></app-char-counter>
                        <div class="invalid-feedback">
                          <div *ngIf="applicationForm.get('projectImplementDescription')?.hasError('notBlank')">
                            Please enter some text or leave this field empty.
                          </div>
                          <div *ngIf="applicationForm.get('projectImplementDescription')?.hasError('maxlength')">
                            Project implementation description cannot exceed {{ reportLimits.projectImplementDescription }} characters.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="reportData && reportData.targetGroupImpact && reportData.targetGroupImpact.length > 0"
                       class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="form-control-label">Target Group - Impacted individuals</label>
                        <ul class="description-list small text-muted">
                          <li>
                            Please select which target groups and stakeholders you have been working with in this
                            project.
                          </li>
                          <li>
                            If your target group is not there, please name them under “other”.
                          </li>
                          <li>
                            Please include numbers and descriptions of the target groups and stakeholders you have
                            engaged with your project.
                          </li>
                        </ul>
                        <div id="TargetGroupTable" class="table-responsive">
                          <table class="table-responsive table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                              <th scope="col">Target Group</th>
                              <th class="text-right" scope="col">Total</th>
                              <th class="text-right" scope="col">Number - Male</th>
                              <th class="text-right" scope="col">Number - Female</th>
                              <th class="text-right" scope="col">Number - Other</th>
                            </tr>
                            </thead>
                            <tbody class="list" formArrayName="targetGroupImpact">
                            <tr *ngFor="let item of targetGroupImpact.controls; let i = index" [formGroupName]="i">
                              <td class="text-wrap">{{ item.get('name')?.value }}</td>
                              <td>
                                <input
                                  type="number"
                                  step="1"
                                  formControlName="impactedIndividualsTotal"
                                  class="form-control form-control-sm text-right"
                                  [min]="reportAmount.min" [max]="reportAmount.max"
                                  placeholder="Total"
                                  [ngClass]="{ 'is-invalid': applicationForm.get(['targetGroupImpact', i, 'impactedIndividualsTotal'])?.invalid && applicationForm.get(['targetGroupImpact', i, 'impactedIndividualsTotal'])?.touched }"
                                />
                                <div
                                  *ngIf="applicationForm.get(['targetGroupImpact', i, 'impactedIndividualsTotal'])?.hasError('wholeNumber') && applicationForm.get(['targetGroupImpact', i, 'impactedIndividualsTotal'])?.touched"
                                  class="invalid-feedback" style="display:block">
                                  Please enter a whole number (no decimals).
                                </div>
                              </td>
                              <td>
                                <input
                                  type="number"
                                  step="1"
                                  formControlName="numberOfMale"
                                  class="form-control form-control-sm text-right"
                                  [min]="reportAmount.min" [max]="reportAmount.max"
                                  placeholder="Male"
                                  [ngClass]="{ 'is-invalid': applicationForm.get(['targetGroupImpact', i, 'numberOfMale'])?.invalid && applicationForm.get(['targetGroupImpact', i, 'numberOfMale'])?.touched }"
                                />
                                <div
                                  *ngIf="applicationForm.get(['targetGroupImpact', i, 'numberOfMale'])?.invalid && applicationForm.get(['targetGroupImpact', i, 'numberOfMale'])?.touched"
                                  class="invalid-feedback">
                                  <span *ngIf="applicationForm.get(['targetGroupImpact', i, 'numberOfMale'])?.hasError('wholeNumber')">Please enter a whole number (no decimals).</span>
                                  <span *ngIf="!applicationForm.get(['targetGroupImpact', i, 'numberOfMale'])?.hasError('wholeNumber')">Please enter a valid number for males.</span>
                                </div>
                              </td>
                              <td>
                                <input
                                  type="number"
                                  step="1"
                                  formControlName="numberOfFemale"
                                  class="form-control form-control-sm text-right"
                                  [min]="reportAmount.min" [max]="reportAmount.max"
                                  placeholder="Female"
                                  [ngClass]="{ 'is-invalid': applicationForm.get(['targetGroupImpact', i, 'numberOfFemale'])?.invalid && applicationForm.get(['targetGroupImpact', i, 'numberOfFemale'])?.touched }"
                                />
                                <div
                                  *ngIf="applicationForm.get(['targetGroupImpact', i, 'numberOfFemale'])?.invalid && applicationForm.get(['targetGroupImpact', i, 'numberOfFemale'])?.touched"
                                  class="invalid-feedback">
                                  <span *ngIf="applicationForm.get(['targetGroupImpact', i, 'numberOfFemale'])?.hasError('wholeNumber')">Please enter a whole number (no decimals).</span>
                                  <span *ngIf="!applicationForm.get(['targetGroupImpact', i, 'numberOfFemale'])?.hasError('wholeNumber')">Please enter a valid number for females.</span>
                                </div>
                              </td>
                              <td>
                                <input
                                  type="number"
                                  step="1"
                                  formControlName="numberOfOther"
                                  class="form-control form-control-sm text-right"
                                  [min]="reportAmount.min" [max]="reportAmount.max"
                                  placeholder="Other"
                                  [ngClass]="{ 'is-invalid': applicationForm.get(['targetGroupImpact', i, 'numberOfOther'])?.invalid && applicationForm.get(['targetGroupImpact', i, 'numberOfOther'])?.touched }"
                                />
                                <div
                                  *ngIf="applicationForm.get(['targetGroupImpact', i, 'numberOfOther'])?.invalid && applicationForm.get(['targetGroupImpact', i, 'numberOfOther'])?.touched"
                                  class="invalid-feedback">
                                  <span *ngIf="applicationForm.get(['targetGroupImpact', i, 'numberOfOther'])?.hasError('wholeNumber')">Please enter a whole number (no decimals).</span>
                                  <span *ngIf="!applicationForm.get(['targetGroupImpact', i, 'numberOfOther'])?.hasError('wholeNumber')">Please enter a valid number for others.</span>
                                </div>
                              </td>
                            </tr>
                            </tbody>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="form-control-label">Other partnerships and networks (Max {{ reportLimits.otherPartnerrAndNetwork }} characters)</label>
                        <ul class="description-list small text-muted">
                          <li>
                            List other human rights partnerships and networks you participate in (formally or
                            informally)
                          </li>
                        </ul>
                        <textarea [ngClass]="{ 'is-invalid': applicationForm.get('otherPartnerrAndNetwork')?.invalid
                                  && applicationForm.get('otherPartnerrAndNetwork')?.touched }"
                                  class="form-control"
                                  formControlName="otherPartnerrAndNetwork" rows="7"
                                  [maxlength]="reportLimits.otherPartnerrAndNetwork"></textarea>
                        <app-char-counter [control]="applicationForm.get('otherPartnerrAndNetwork')"
                                          [max]="reportLimits.otherPartnerrAndNetwork"
                                          [lineBreakCost]="1"></app-char-counter>
                        <div class="invalid-feedback">
                          <div *ngIf="applicationForm.get('otherPartnerrAndNetwork')?.hasError('notBlank')">
                            Please enter some text or leave this field empty.
                          </div>
                          <div *ngIf="applicationForm.get('otherPartnerrAndNetwork')?.hasError('maxlength')">
                            Other partnerships and networks cannot exceed {{ reportLimits.otherPartnerrAndNetwork }} characters.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="form-control-label">Cross-cutting issues for democratic development (Max {{ reportLimits.crossCuttingIssue }} characters)</label>
                        <ul class="description-list small text-muted">
                          <li>
                            Explain briefly how you have addressed each of these points in your work: a) gender
                            equality; b) rights of LGBTI persons, minorities of religion and belief, other minorities;
                            c) anti-corruption; d) climate and environment.
                          </li>
                        </ul>
                        <textarea [ngClass]="{ 'is-invalid': applicationForm.get('crossCuttingIssue')?.invalid
                                  && applicationForm.get('crossCuttingIssue')?.touched }"
                                  class="form-control"
                                  formControlName="crossCuttingIssue" rows="7"
                                  [maxlength]="reportLimits.crossCuttingIssue"></textarea>
                        <app-char-counter [control]="applicationForm.get('crossCuttingIssue')"
                                          [max]="reportLimits.crossCuttingIssue"
                                          [lineBreakCost]="1"></app-char-counter>
                        <div class="invalid-feedback">
                          <div *ngIf="applicationForm.get('crossCuttingIssue')?.hasError('notBlank')">
                            Please enter some text or leave this field empty.
                          </div>
                          <div *ngIf="applicationForm.get('crossCuttingIssue')?.hasError('maxlength')">
                            Cross-cutting issues for democratic development cannot exceed {{ reportLimits.crossCuttingIssue }} characters.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="form-control-label">What story would you like us to tell from your
                          project? (Max {{ reportLimits.whatStory }} characters)</label>
                        <ul class="description-list small text-muted">
                          <li>
                            Please describe one specific story, that you think would be a significant example for others
                            (the general public, donors, policy makers) to read about, and include materials like
                            photos, video, reports, links to media articles or any other relevant material. Try to tell
                            freely about your example, both what it is about, and why you chose exactly this one.
                            Reflect on why this specific story is representative of your country, region and not the
                            least – your project.
                          </li>

                        </ul>
                        <ul class="description-list small text-muted">
                          <li>
                            Please indicate if this is a story we could use for public purposes, or if it should be kept
                            confidential. If you include names of persons, please advise us whether this can be used
                            publicly or not.
                          </li>
                        </ul>
                        <textarea [ngClass]="{ 'is-invalid': applicationForm.get('whatStory')?.invalid
                                  && applicationForm.get('whatStory')?.touched }"
                                  class="form-control"
                                  formControlName="whatStory" rows="7"
                                  [maxlength]="reportLimits.whatStory"></textarea>
                        <app-char-counter [control]="applicationForm.get('whatStory')"
                                          [max]="reportLimits.whatStory"
                                          [lineBreakCost]="1"></app-char-counter>
                        <div class="invalid-feedback">
                          <div *ngIf="applicationForm.get('whatStory')?.hasError('notBlank')">
                            Please enter some text or leave this field empty.
                          </div>
                          <div *ngIf="applicationForm.get('whatStory')?.hasError('maxlength')">
                            What story cannot exceed {{ reportLimits.whatStory }} characters.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class=" card-wrapper">
            <div class="card">
              <div class="card-body">
                <button class="btn btn-primary" type="submit">Submit</button>
                <button class="btn btn-outline-primary" type="button" (click)="onSaveDraft()">Save Draft</button>
                <button (click)="navigateToDetails()" class="btn btn-secondary" type="button">Back</button>
              </div>
            </div>
          </div>



        </form>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-12 col-lg-12 col-sm-12">
                <h3 class=" mb-0">Attachments</h3>
                <span *ngIf="reportData?.reportTypeCode === 'StatusReportNarrative'" class="small text-muted">Upload report form (required)</span>
                <span *ngIf="reportData?.reportTypeCode === 'FinalReportNarrative'" class="small text-muted">Upload Final report form (required)</span>
                <ul *ngIf="reportData?.reportTypeCode === 'FinalReportFinancial'||reportData?.reportTypeCode === 'StatusReportFinancial'"
                    class="description-list small text-muted">
                  <li>
                    Upload Attestation of project reports (mandatory)
                  </li>
                  <li>
                    Upload receipts (mandatory)
                  </li>
                  <li>
                    Upload Financial report (mandatory)
                  </li>
                  <li>
                    Upload Breakdown of expenditures (mandatory)
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body">
            <app-upload-form *ngIf="!(reportData?.reportTypeCode === 'FinalReportFinancial'|| reportData?.reportTypeCode === 'StatusReportFinancial')"
                             [data]="reportData?.reportFiles"
                             [documentDatas]="documentDatas()"
                             [parentForm]="applicationForm"
            >

            </app-upload-form>
            <app-dropdown-upload-form
              *ngIf="(reportData?.reportTypeCode === 'FinalReportFinancial' || reportData?.reportTypeCode === 'StatusReportFinancial')"
              [data]="reportData?.reportFiles"
              [documentDatas]="documentDatas()"
              [parentForm]="applicationForm"
              [documentTypeList]="documentType"
            >

            </app-dropdown-upload-form>

          </div>
        </div>
      </div>
    </div>


  </section>
</div>
